import React, { useRef } from 'react';
import { Typography } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import FreeAttractionCard from '../freeAttractionCard/FreeAttractionCard';
import './FreeAttractions.css';
import languageStore from '../../store/languageStore';
import { t } from 'i18next';

const { Title, Text } = Typography;

const FreeAttractions = ({ title, description, attractions }) => {
  const containerRef = useRef(null);

  const scroll = (direction) => {
    if (direction === 'left') {
      containerRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    } else {
      containerRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    }
  };

  return (
    <div className='free-attractions'>
      <div className='free-attractions-title-container'>
        <h3 className='free-attractions-title'>{title}</h3>
        <Text className='free-attractions-description'>{description}</Text>
      </div>

      <div className='attractions-wrapper'>
        <button className='scroll-button left' onClick={() => scroll('left')}>
          <LeftOutlined />
        </button>
        <div className='attractions-container' ref={containerRef}>
          {attractions.map((attraction, index) => (
            <div key={index} className='free-attraction-card'>
              <FreeAttractionCard
                imageSrc={`https://static2.praguecoolpass.com/${attraction?.images[0]}`}
                title={attraction?.content[languageStore.selectedLanguage]?.title}
                subtitle={attraction?.content[languageStore.selectedLanguage]?.subtitle}
                badgeText={t("FREE_PUBLIC_ENTRY_LABEL")}
              />
            </div>
          ))}
        </div>
        <button className='scroll-button right' onClick={() => scroll('right')}>
          <RightOutlined />
        </button>
      </div>
    </div>
  );
};

export default FreeAttractions;
